function cleanResponse (text) {
  return text
    .replace(/\$\\rightarrow\$/g, '→')
    .replace(/\\rightarrow/g, '→')
    .replace(/\$\\leftarrow\$/g, '←')
    .replace(/\\uparrow/g, '↑')
    .replace(/\\downarrow/g, '↓')
    .replace(/\$([^$]*)\$/g, '$1')
    .replace(/\*\*([^*]+)\*\*/g, '$1')
    .replace(/^#{1,6}\s+/gm, '')
    .replace(/^---+$/gm, '')
}

function readMessages (messages) {
  if (!Array.isArray(messages)) return []
  return messages.map(message => ({
    ...message,
    content: message.role === 'assistant' ? cleanResponse(message.content) : message.content
  }))
}

function requestError (error, fallback, missingConversation = false) {
  const status = error.response && error.response.status
  const data = (error.response && error.response.data) || {}
  let message = fallback
  if (status === 401) {
    message = '登入狀態已失效，請重新登入後再試。'
  } else if (status === 404) {
    message = missingConversation
      ? '對話已過期或不存在，請開始新對話。'
      : 'AI 助手服務尚未設定，請聯絡管理員。'
  } else if (status === 429) {
    message = data.message || '提問次數過於頻繁，請稍後再試。'
  } else if (status === 503) {
    message = data.message || 'AI 助手暫時未能回覆，請稍後再試。'
  } else if (status === 422) {
    message = data.message || '訊息未能送出，請檢查內容後再試。'
  }
  return {
    success: false,
    status,
    message,
    conversationId: data.conversation_id || null,
    messages: readMessages(data.messages)
  }
}

export async function listConversations (page = 1) {
  try {
    const { data } = await window.axios.get('chatbot/conversations', {
      params: { page },
      timeout: 20000
    })
    return { success: true, conversations: data.conversations, nextPage: data.next_page }
  } catch (error) {
    return requestError(error, '未能載入歷史對話，請檢查網絡連線後再試。')
  }
}

export async function getConversation (conversationId, beforeId = null) {
  try {
    const { data } = await window.axios.get(`chatbot/conversations/${conversationId}/messages`, {
      params: beforeId ? { before_id: beforeId } : {},
      timeout: 20000
    })
    return {
      success: true,
      conversation: data.conversation,
      messages: readMessages(data.messages),
      nextBeforeId: data.next_before_id
    }
  } catch (error) {
    return requestError(error, '未能載入對話內容，請檢查網絡連線後再試。', true)
  }
}

export async function sendMessage (message, conversationId = null) {
  try {
    const { data } = await window.axios.post('chatbot/completions', {
      message,
      ...(conversationId ? { conversation_id: conversationId } : {})
    }, {
      timeout: 60000
    })
    return {
      success: true,
      message: cleanResponse(data.message),
      conversationId: data.conversation_id,
      messages: readMessages(data.messages)
    }
  } catch (error) {
    return requestError(error, '網絡錯誤，未能確認訊息是否已儲存。請重新載入歷史對話後再試。', !!conversationId)
  }
}
